<template>
    <CompassDescriptionList
        :size="descriptionListSize"
        :variant="descriptionListVariant"
        class="object-block__description-list"
    >
        <CompassDescriptionListItem
            v-if="showCompany && data.company"
            :label="$t.__('email.EmailRelatedObject.company')"
        >
            <CompassLink :label="data.company.name" :link="data.company.link" target="_blank" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showContact && data.contact"
            :label="$t.__('common.labels.contact')"
        >
            <CompassLink :label="data.contact.fullName" :link="data.contact.link" target="_blank" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showEmail && data.email"
            :label="$t.__('common.labels.email')"
        >
            <ContactDetails :value="data.email" variant="email" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showPhone && data.phone_number"
            :label="$t.__('common.labels.phone')"
        >
            <ContactDetails :value="data.phone_number" variant="phone" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showMobile && data.mobile_number"
            :label="$t.__('common.labels.mobile')"
        >
            <ContactDetails :value="data.mobile_number" variant="phone" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showAddress && data.address"
            :label="$t.__('common.labels.address')"
        >
            {{ data.address.street }}<br />
            {{ data.address.postal_code }} {{ data.address.city }}
        </CompassDescriptionListItem>
    </CompassDescriptionList>
</template>
<script setup lang="ts">
import ContactDetails from 'vcomponents/common/object/ContactDetails.vue';
import { OBJECT_BLOCK_VARIANT } from 'Dictionaries/commonComponents/ObjectBlockEnums';
import { computed } from 'vue';

interface BlockDescriptionListData {
    company?: { name: string; link: string };
    contact?: { fullName: string; link: string };
    email?: string;
    phone_number?: string;
    mobile_number?: string;
    address?: { street: string; postal_code: string; city: string };
}

interface Props {
    data: BlockDescriptionListData;
    variant: OBJECT_BLOCK_VARIANT;
    showEmail?: boolean;
    showPhone?: boolean;
    showMobile?: boolean;
    showAddress?: boolean;
    showCompany?: boolean;
    showContact?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    showEmail: true,
    showPhone: true,
    showMobile: true,
    showAddress: true,
    showCompany: true,
    showContact: true,
});

const descriptionListVariant = computed<string>(() => {
    return props.variant === OBJECT_BLOCK_VARIANT.LINKED
        ? CompassEnums.DescriptionListVariantType.FROZEN_FIELD
        : CompassEnums.DescriptionListVariantType.LISTING;
});

const descriptionListSize = computed<string>(() => {
    return props.variant === OBJECT_BLOCK_VARIANT.LINKED
        ? CompassEnums.DescriptionListSize.MEDIUM
        : CompassEnums.DescriptionListSize.SMALL;
});

defineOptions({ inheritAttrs: false });
</script>

<style lang="scss" scoped>
.object-block__description-list:deep() {
    margin: var(--spacing-1) 0 0;

    .compass-description-list__item__content {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }
}
</style>
